var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.96651C14.95 5.95817 14.8917 5.95817 14.8417 5.96651C13.6917 5.92484 12.775 4.98317 12.775 3.81651C12.775 2.62484 13.7333 1.6665 14.925 1.6665C16.1167 1.6665 17.075 2.63317 17.075 3.81651C17.0667 4.98317 16.15 5.92484 15 5.96651Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 12.0333C15.2833 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5333 7.99164 15.2583 7.79163 14.1167 7.99163",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.975 5.96651C5.025 5.95817 5.08333 5.95817 5.13333 5.96651C6.28333 5.92484 7.2 4.98317 7.2 3.81651C7.2 2.62484 6.24167 1.6665 5.05 1.6665C3.85833 1.6665 2.9 2.63317 2.9 3.81651C2.90833 4.98317 3.825 5.92484 4.975 5.96651Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 12.0333C4.69167 12.225 3.43334 12.025 2.55 11.4333C1.375 10.65 1.375 9.36664 2.55 8.58331C3.44167 7.99164 4.71667 7.79163 5.85833 7.99163",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.1916C9.95 12.1833 9.89167 12.1833 9.84167 12.1916C8.69167 12.1499 7.775 11.2083 7.775 10.0416C7.775 8.84994 8.73333 7.8916 9.925 7.8916C11.1167 7.8916 12.075 8.85827 12.075 10.0416C12.0667 11.2083 11.15 12.1583 10 12.1916Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.425 14.8168C11.1 13.9335 8.90833 13.9335 7.575 14.8168C6.4 15.6001 6.4 16.8835 7.575 17.6668C8.90833 18.5585 11.0917 18.5585 12.425 17.6668",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUser);
export default __webpack_public_path__ + "static/media/activeUser.e9b61f428539fef402377b12e88e5c47.svg";
export { ForwardRef as ReactComponent };